<capra-button
  [text]="displayValue"
  variant="secondary"
  size="small"
  color="neutral"
  icon="icon-caret-down"
  iconLocation="right"
  [matMenuTriggerFor]="menu"
  data-test="language-dropdown"
></capra-button>
<mat-menu #menu="matMenu" xPosition="after" class="mat-menu-container">
  <ul>
    <li role="button" (click)="onSelectionChange(lang)" *ngFor="let lang of dropdownData" [type]="lang.type">
      <div class="item-icon" [class.active]="lang.name === displayValue"></div>
      {{ lang.name }}
    </li>
  </ul>
</mat-menu>
